export default __webpack_public_path__ + "static/media/favicon.58475002.ico";